import axios from "axios";
import { broadcastSessionEvent, loginPathWithNotice } from "./sessionSync";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BASE}/api`;

const api = axios.create({ baseURL: API_URL, withCredentials: true });

const readCookie = (name) =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`))
    ?.split("=")[1] || "";

api.interceptors.request.use((config) => {
  if (
    !["get", "head", "options"].includes((config.method || "get").toLowerCase())
  ) {
    const token = readCookie("csrf_token");
    if (token) config.headers["X-CSRF-Token"] = token;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 503 && err.response?.data?.detail?.code === "maintenance") {
      if (window.location.pathname !== "/maintenance") {
        window.location.assign("/maintenance");
      }
    }
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      const publicPaths = [
        "/login",
        "/",
        "/forgot-password",
        "/reset-password",
        "/accept-invite",
        "/maintenance",
        "/emergency-access",
      ];
      if (!publicPaths.includes(path)) {
        const timedOut =
          err.response?.data?.detail?.code === "inactivity_timeout";
        if (timedOut) broadcastSessionEvent({ type: "inactivity" });
        window.location.assign(
          loginPathWithNotice(timedOut ? "inactivity" : ""),
        );
      }
    }
    return Promise.reject(err);
  },
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (typeof detail === "object" && detail.msg) return detail.msg;
  return String(detail);
}

export async function downloadFile(path, fallbackName, params) {
  const { data, headers } = await api.get(path, {
    params,
    responseType: "blob",
  });
  const disposition = headers?.["content-disposition"] || "";
  const match = disposition.match(/filename="?([^";]+)"?/);
  const url = URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = url;
  link.download = match ? match[1] : fallbackName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export default api;
